<template>
  <div class="w-full flex flex-col min-h-screen bg-[#0E171F] text-white ">
    <!-- Navbar -->
    <div class="w-full flex justify-center h-20  md:h-28 fixed bg-[#0E171F] z-50">
      <div class="h-full w-11/12 flex justify-between items-center">
        <!-- Logo -->
        <div @click="$router.push('/')" class="h-full flex justify-center items-center cursor-pointer">
          <img src="/images/logo/logo_text_white.png" class="h-20 md:h-28" alt="Logo" />
        </div>

        <!-- Menu Desktop -->
        <div class="hidden md:flex h-full items-center space-x-3">
          <router-link v-for="(item, index) in navItems" :key="index" :to="item.link"
            class="text-[#e6204b] font-alize hover:text-white transition duration-300 underline text-lg font-semibold uppercase">
            {{ $t(item.label) }}
          </router-link>
          <router-link v-if="!auth" to="/login"
            class="text-[#e6204b] hover:text-white transition duration-300 font-alize underline text-lg font-semibold uppercase">
            {{ $t('seconnecter') }}
          </router-link>
          <router-link v-else to="/Reservations"
            class="text-[#e6204b] hover:text-white transition duration-300 font-alize underline text-lg font-semibold uppercase">
            {{ $t('reservations') }}
          </router-link>
        </div>

        <!-- Language Switcher & Mobile Menu Button -->
        <div class="flex items-center space-x-2 md:space-x-4">
          <language-switcher />
          <button @click="toggleSidebar" class="md:hidden text-white focus:outline-none">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 md:h-8 w-4 md:w-8" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>
    </div>
    <div class="h-20  md:h-28"></div>

    <!-- Sidebar Mobile -->
    <transition name="slide">
      <div v-if="isSidebarOpen" class="fixed inset-0 z-[5000]">
        <div class="w-full h-full bg-[#0E171F] bg-opacity-50 z-40  absolute" @click.self="toggleSidebar"></div>
        <div class="h-full flex flex-col z-50 absolute">
          <div
            class="w-64 bg-[#0E171F] border-r border-[#e6204b] h-full p-6 space-y-4  transform transition-transform duration-300">
            <button @click="toggleSidebar" class="text-white text-2xl mb-4 focus:outline-none ">&times;</button>
            <router-link v-for="(item, index) in navItems" :key="index" :to="item.link" @click="toggleSidebar"
              class="block text-[#e6204b] hover:text-white transition duration-300 underline text-lg font-semibold uppercase font-alize">
              {{ $t(item.label) }}
            </router-link>
            <router-link v-if="!auth" to="/login" @click="toggleSidebar"
              class="block text-[#e6204b] hover:text-white transition duration-300 underline text-lg font-semibold uppercase font-alize">
              {{ $t('seconnecter') }}
            </router-link>
            <router-link v-else to="/Reservations" @click="toggleSidebar"
              class="block text-[#e6204b] hover:text-white transition duration-300 underline text-lg font-semibold uppercase font-alize">
              {{ $t('reservations') }}
            </router-link>

          </div>
          <div class="flex border-r border-[#e6204b] border-t justify-center space-x-4 items-center bg-[#0E171F] py-3">
            <a href="https://www.facebook.com/letmewaxyou/"
              class="h-8 w-8 rounded-  flex justify-center items-center overflow-hidden">
              <img src="/images/facebook-logo.png" class="object-cover object-center w-full h-full " alt="">
            </a>
            <a href="https://www.instagram.com/letmewaxyou/"
              class="h-8 w-8 rounded-full  flex justify-center items-center overflow-hidden">
              <img src="/images/image.png" class="object-cover object-center w-full h-full " alt="">
            </a>
            <div class="h-8 w-8 rounded-full  flex justify-center items-center overflow-hidden">
              <router-link to="/Contact">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6">
                  <path fill-rule="evenodd"
                    d="M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z"
                    clip-rule="evenodd" />
                </svg>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </transition>


    <div class="font-alegreya">
      <router-view name="one" />
    </div>




    <div
      class="flex flex-col items-center justify-center space-y-2 border-t border-[#e6204b] bg-[#0E171F] py-4 text-white text-sm">
      <!-- Réseaux sociaux et Contact -->
      <div class="flex justify-center space-x-4 items-center">
        <a href="https://www.facebook.com/letmewaxyou/"
          class="h-8 w-8 rounded-full flex justify-center items-center overflow-hidden hover:opacity-80 transition">
          <img src="/images/facebook-logo.png" class="object-cover object-center w-full h-full" alt="Facebook">
        </a>

        <a href="https://www.instagram.com/letmewaxyou/"
          class="h-8 w-8 rounded-full flex justify-center items-center overflow-hidden hover:opacity-80 transition">
          <img src="/images/insta-logo.png" class="object-cover object-center w-full h-full" alt="Instagram">
        </a>

        <router-link to="/contact"
          class="h-8 w-8 rounded-full flex justify-center items-center hover:opacity-80 transition">
          <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="size-6" viewBox="0 0 24 24">
            <path fill-rule="evenodd"
              d="M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z"
              clip-rule="evenodd" />
          </svg>
        </router-link>
      </div>

      <!-- Liens supplémentaires -->
      <div class="flex flex-wrap justify-center space-x-4 mt-2 text-xs sm:text-sm">
        <router-link to="/privacy" class="hover:underline hover:text-[#FFB701] transition">Politique de
          confidentialité</router-link>
        <span>|</span>
        <router-link to="/license" class="hover:underline hover:text-[#FFB701] transition">Licence</router-link>
      </div>
    </div>


  </div>
</template>

<script>
import LanguageSwitcher from './LanguageSwitcher.vue';

export default {
  components: { LanguageSwitcher },
  data() {
    return {
      isSidebarOpen: false,
      auth: false,
      navItems: [
        { label: 'programme', link: '/Programme' },
        { label: 'quisommesnous', link: '/a-propos' },
        { label: 'partenaires', link: '/partenaires' },
        { label: 'artistes', link: '/Artistes' },
        { label: 'tickets', link: '/tickets' },
        { label: 'gallerie', link: '/gallery' },
      ],
    };
  },
  mounted() {
    this.auth = !!localStorage.getItem('jwtToken');

    if (localStorage.getItem("jwtToken")) {
      this.auth = true
    }

    this.paiment = localStorage.getItem("paiement")
    if (this.paiment == true) {
      this.$router.push("/success")
    }
  },
  methods: {
    toggleSidebar() {
      console.log("click")
      this.isSidebarOpen = !this.isSidebarOpen;
    },
  },
};
</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}

.slide-enter-from {
  transform: translateX(-100%);
}

.slide-enter-to {
  transform: translateX(0);
}

.slide-leave-from {
  transform: translateX(0);
}

.slide-leave-to {
  transform: translateX(-100%);
}
</style>